import {TemplateList} from "~/libs/constants/TemplateList"
import type SocialItem from "~/libs/interfaces/SocialItem"
import {SocialList} from "~/libs/constants/SocialList";

export const SocialListTemplateConfig: Record<TemplateList, SocialItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'X',
      id: SocialList.X,
      // url: 'https://x.com/poggerscz',
      shareUrl:'https://x.com/intent/post?url='
    },
    {
      name: 'Threads',
      id: SocialList.THREADS,
      url: 'https://www.threads.net/@poggerscz',
      shareUrl:''
    },
    {
      name: 'Facebook',
      id: SocialList.FACEBOOK,
      // url: '/tbd',
      shareUrl:'https://www.facebook.com/sharer/sharer.php?u='
    },
    {
      name: 'Instagram',
      id: SocialList.INSTAGRAM,
      url: 'https://www.instagram.com/poggerscz'
    },
    {
      name: 'YouTube',
      id: SocialList.YOUTUBE,
      url: 'https://www.youtube.com/@poggerscz'
    },
    {
      name: 'Tiktok',
      id: SocialList.TIKTOK,
      url: 'https://www.tiktok.com/@poggerscz'
    },
    {
      name: 'Discord',
      id: SocialList.DISCORD,
      url: 'https://discord.com/invite/g7cyGceA9n'
    },
    {
      name: 'WhatsApp',
      id: SocialList.WHATSAPP,
      shareUrl:'https://api.whatsapp.com/send?text='
    },
    {
      name: 'Pogtv',
      id: SocialList.POGTV,
      url: 'https://www.twitch.tv/team/poggerscz'
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'X',
      id: SocialList.X,
      shareUrl:'https://x.com/intent/post?url='
    },
    {
      name: 'Facebook',
      id: SocialList.FACEBOOK,
      url: 'https://www.facebook.com/casopisMateridouska',
      shareUrl:'https://www.facebook.com/sharer/sharer.php?u='
    },
    {
      name: 'Instagram',
      id: SocialList.INSTAGRAM,
      url: 'https://www.instagram.com/materidouska_casopis/'
    },
    {
      name: 'YouTube',
      id: SocialList.YOUTUBE,
      url: 'https://www.youtube.com/@materidouskacz'
    },
    {
      name: 'WhatsApp',
      id: SocialList.WHATSAPP,
      shareUrl:'https://api.whatsapp.com/send?text='
    },
    {
      name: 'Tiktok',
      id: SocialList.TIKTOK,
      url: 'https://www.tiktok.com/@casopismateridouska'
    },
  ]
}